import { LINK } from '@constants';
import { ArrowRight, Button, Column, Empty, Icon, Refresh, Row, Typography } from '@viewup/ui';
import { useGetActiveNBlogAccount, useGetPostCampaigns } from 'app/viewing/_entities/post';
import { CheckBeforeApplyButton } from 'app/viewing/_features/post';
import { useRouter } from 'next/navigation';
import { ApplyCard } from '../ApplyCard';

export const PostCampaignList = () => {
  const router = useRouter();
  const { data: blogAccount } = useGetActiveNBlogAccount();
  const { data: response, refetch } = useGetPostCampaigns();
  const isEmpty = (response?.campaigns.length || 0) <= 0;
  const campaigns = response?.campaigns && response.campaigns;

  const handleRefresh = () => refetch();

  return (
    <Column css={{ height: '100%', overflow: 'auto' }} gap={16} height={'100%'}>
      <CheckBeforeApplyButton />
      <Row justifyContent='flex-end'>
        <Button
          leftContent={<Icon source={Refresh} />}
          onClick={handleRefresh}
          size='S'
          variant='outline.primary'
        >
          새로운 캠페인으로 새로고침
        </Button>
      </Row>
      {isEmpty && (
        <Column alignItems='center' height={'calc(100svh - 352px)'} justifyContent='center'>
          <Column
            alignItems='center'
            gap={8}
            height={'100%'}
            justifyContent='center'
            width={'100%'}
          >
            <Empty />
            <Typography color='text.tertiary' fontType='body.medium' mb={8} mt={40}>
              새 캠페인으로 곧 찾아올게요!
            </Typography>
            <Typography color='text.disabled' fontType='body2.regular' mb={40}>
              기다리는 동안 다양한 뷰업활동을 해보세요.
            </Typography>
            <Button
              onClick={() => router.push(LINK.VIEWING)}
              rightContent={<Icon source={ArrowRight} />}
              size='S'
              variant='ghost.primary'
            >
              뷰업활동하러 가기
            </Button>
          </Column>
        </Column>
      )}

      {/* 빈 목록일 땐 앵커째로 렌더하지 않아 투어 스텝이 스킵되게 한다.
          앵커를 스크롤 컨테이너가 아닌 카드 묶음에만 씌워 하이라이트가 캠페인만 가리키도록 한다. */}
      {!isEmpty && (
        <Column data-tour='post-campaign-list' gap={16}>
          {campaigns?.map(
            ({ campaignName: name, description, rewardPoint, campaignUuid: uuid, options }) => (
              <ApplyCard
                campaignUuid={uuid}
                description={description}
                key={uuid}
                name={name}
                options={options}
                point={rewardPoint}
                snsAccountUuid={blogAccount?.accountUuid || ''}
              />
            ),
          )}
        </Column>
      )}
    </Column>
  );
};
